import createDomPurify, { Config as DomPurifyConfig } from 'dompurify';
import { METADATA_TAG_NAMES } from './content';
import { getGlobalWindowOrThrow } from './global';

const domPurifyConfig: DomPurifyConfig = {
  RETURN_DOM_FRAGMENT: true,
  FORCE_BODY: true,
  FORBID_TAGS: Array.from(METADATA_TAG_NAMES),
};

/** Provides a temporary DOM with sanitized and deserialized HTML. */
export function dirtyHtmlToDom<T>(dirtyHtml: string, callback: (container: Node) => T): T {
  // We've already set the config earlier, but this helps TypeScript infer a DocumentFragment is returned.
  const fragment = getDomPurify().sanitize(dirtyHtml, {
    RETURN_DOM_FRAGMENT: true,
  });

  return callback(fragment);
}

/** Provides a temporary DOM with deserialized HTML that has already been sanitized. */
export function cleanHtmlToDom<T>(cleanHtml: string, callback: (container: Node) => T): T {
  const parser = new DOMParser();
  const temporaryDocument = parser.parseFromString(cleanHtml, 'text/html');
  const temporaryBody: Node | null = temporaryDocument.body;

  return callback(temporaryBody || temporaryDocument.createDocumentFragment());
}

type DomPurify = ReturnType<typeof createDomPurify>;
let domPurify: DomPurify | undefined;

function getDomPurify(): DomPurify {
  if (!domPurify) {
    const window = getGlobalWindowOrThrow();
    domPurify = createDomPurify(window);
    domPurify.setConfig(domPurifyConfig);
  }

  return domPurify;
}
